<top-banner variant="small"></top-banner>

<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body mb-2">
          <card-section-header
              title="Contractors"
              icon="fas fa-list"
              buttonLabel="INVITE NEW CONTRACTOR"
              buttonIcon="fas fa-envelope"
              [showButton]="!isReadOnly"
              (buttonClick)="goToContractorInvite()">
          </card-section-header>
          <!-- Filter -->
          <div class="form-row">
            <div class="row">
              <div class="col-md-12">
                <div class="filter-flex-row">
                  <div>
                    <label>Company Name:</label>
                    <text-filter-box (onFilterTextChanged)="onFilterTextChanged($event)"></text-filter-box>
                  </div>
                  <div *ngIf="isFilterLoading" class="small-spinner">
                    <p-progressSpinner [strokeWidth]="5"></p-progressSpinner>
                  </div>
                </div>
                <br>
              </div>
            </div>
          </div>
          <!-- Table of results -->
          <div class="row">
            <div class="col-md-12">
              <p-table
              [autoLayout]="true"
              [value]="contractors"
              selectionMode="single"
              (onRowSelect)="onRowSelect($event)"
              (onSort)="customSort($event)"
              [sortField]="defaultSortField"
              [sortOrder]="defaultSortOrder"
              [lazy]="true"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th [pSortableColumn]="'name'">Company Name
                      <p-sortIcon [field]="'name'"></p-sortIcon>
                    </th>
                    <th>Manager</th>
                    <th>Status</th>
                    <th>Additional Information</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-company>
                  <tr [pSelectableRow]="company">
                    <td>{{ company.name }}</td>
                    <td>{{ company.manager ? company.manager : 'N/A' }}</td>
                    <td>
                      <span *ngIf="company.maintenanceSiteOwnerStatus === 'APPROVED'" class="badge badge-pill badge-success">Approved</span>
                      <span *ngIf="company.maintenanceSiteOwnerStatus === 'PENDING_APPROVAL'" class="badge badge-pill badge-warning">Pending Approval</span>
                      <span *ngIf="company.maintenanceSiteOwnerStatus === 'PENDING_UPLOAD'" class="badge badge-pill badge-warning">Pending Upload of Certificates</span>
                      <span *ngIf="company.maintenanceSiteOwnerStatus === 'PENDING_RENEWAL'" class="badge badge-pill badge-warning">Expired Certificates</span>
                    </td>
                    <td>{{ company.additionalInfo }}</td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td [attr.colspan]="4">No contractors found</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <p-paginator
            #paginator
            [rows]="pagination.size"
            [totalRecords]="pagination.totalRecords"
            [rowsPerPageOptions]="pageSizes"
            (onPageChange)="paginate($event)">
          </p-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
